import { React, useState } from "react";
import { CiSearch } from "react-icons/ci";

const Leaderboard = ({ archiveData }) => {
  const [Search, setSearch] = useState("");
  const Total = (ch) => {
    var total = 0;
    for (let index = 0; index < 12; index++) {
      total += Number(ch[index]);
    }
    return total;
  };
  function rankLeaderboard(data) {
    const sorted = [...data].sort((a, b) => Total(b.Score) - Total(a.Score));

    return sorted.map((entry, index) => ({
      ...entry,
      rank: index + 1,
    }));
  }

  return (
    <div>
      <div className="Header">
        <h1>LeaderBoard :</h1>
        <form action="search-container" className="search-container">
          <CiSearch className="icon" />
          <input
            type="text"
            id="search-bar"
            placeholder="Search Community"
            onChange={(e) => setSearch(e.target.value)}
          />
        </form>
      </div>

      <div className="table-container Scrollable-table">
        <table className="archive-table">
          <thead>
            <tr>
              <th>Rank</th>
              <th>Participant</th>
              <th>P1</th>
              <th>P2</th>
              <th>P3</th>
              <th>P4</th>
              <th>P5</th>
              <th>P6</th>
              <th>P7</th>
              <th>P8</th>
              <th>P9</th>
              <th>P10</th>
              <th>P11</th>
              <th>P12</th>
              <th>Total</th>
              <th>Reward</th>
            </tr>
          </thead>
          <tbody>
            {rankLeaderboard(archiveData)
              .filter((el) =>
                el.Name.toLowerCase().includes(Search.toLowerCase())
              )
              .map((item, index) => (
                <tr key={index}>
                  <td>{item.rank}</td>
                  <td>
                    <a href={item.Profile}>{item.Name}</a>
                  </td>
                  <td>{item.Score[0]}</td>
                  <td>{item.Score[1]}</td>
                  <td>{item.Score[2]}</td>
                  <td>{item.Score[3]}</td>
                  <td>{item.Score[4]}</td>
                  <td>{item.Score[5]}</td>
                  <td>{item.Score[6]}</td>
                  <td>{item.Score[7]}</td>
                  <td>{item.Score[8]}</td>
                  <td>{item.Score[9]}</td>
                  <td>{item.Score[10]}</td>
                  <td>{item.Score[11]}</td>
                  <td>{Total(item.Score)}</td>
                  <td>{item.Reward}</td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Leaderboard;
